/**
 * @generated SignedSource<<2be3596c5c01b0a780f7f5b28491e34d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
      }
    ],
    "concreteType": "AccountLedgerSummary",
    "kind": "LinkedField",
    "name": "getaccountledgersummary",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetAndArBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetArAuthBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "equityBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxPayoutBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "liabilityBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "authBalance",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BalanceTilesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BalanceTilesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7001192513760ed0ee08072df082ef17",
    "id": null,
    "metadata": {},
    "name": "BalanceTilesQuery",
    "operationKind": "query",
    "text": "query BalanceTilesQuery(\n  $accountId: UUID!\n) {\n  getaccountledgersummary(accountId: $accountId) {\n    assetBalance\n    assetAndArBalance\n    assetArAuthBalance\n    equityBalance\n    maxPayoutBalance\n    liabilityBalance\n    authBalance\n  }\n}\n"
  }
};
})();

node.hash = "95e20c4c53d501d53fa159c18cdaeec5";

module.exports = node;
